import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import DriveEtaRoundedIcon from "@mui/icons-material/DriveEtaRounded";
import AllInboxRoundedIcon from "@mui/icons-material/AllInboxRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import SupervisedUserCircleRoundedIcon from "@mui/icons-material/SupervisedUserCircleRounded";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import { HOME_NURSING_BASE_URL, HOME_NURSING_IS_DEV } from "../newborn/api/homeNursingClient";
import {
  getVendorFromPartnerUUID,
  hasCalendarAccess,
  shouldShowHomeNursingTabs,
  shouldShowHomeNursingRevenueTracker,
} from "../newborn/lib/constants/vendor-mapping";

export const deliveryPartnerMenuItems = [
  {
    href: "/",
    icon: <AllInboxRoundedIcon />,
    label: "Orders",
  },
  {
    icon: <TrendingUpRoundedIcon />,
    href: "/delivery-partner-revenue",
    label: "Revenue",
  },
  {
    icon: <SettingsRoundedIcon />,
    href: "/settings",
    label: "Settings",
  },
];

const allMenuItems = [
  {
    href: "/",
    icon: <AllInboxRoundedIcon />,
    label: "Bookings",
  },
  {
    href: "/care-plan",
    icon: <AssignmentRoundedIcon />,
    label: "Home Nursing",
  },
  // {
  //   href: "/caregivers",
  //   icon: <SupervisedUserCircleRoundedIcon />,
  //   label: "Caregivers",
  // },
  {
    href: "/revenue-tracker",
    icon: <AttachMoneyRoundedIcon />,
    label: "HN Revenue",
  },
  {
    href: "/scheduler",
    icon: <CalendarMonthRoundedIcon />,
    label: "Staff Scheduler",
  },
  {
    href: "/newborn/calendar",
    icon: <EventAvailableRoundedIcon />,
    label: "Caregiver Calendar",
    requiresCalendarAccess: true,
  },
  {
    href: "/new-driver-schedule",
    icon: <DriveEtaRoundedIcon />,
    label: "Mobility Tool",
  },
  {
    href: "/team",
    label: "Staffing",
    icon: <PeopleAltRoundedIcon />,
  },
  {
    href: "/traction",
    label: "Revenue Tracker",
    icon: <TrendingUpRoundedIcon />,
  },
  {
    icon: <SettingsRoundedIcon />,
    href: "/settings",
    label: "Settings",
  },
];

export function getMenuItems(partnerUUID: string | undefined) {
  const vendorName = getVendorFromPartnerUUID(partnerUUID);
  const canAccessCalendar = hasCalendarAccess(vendorName);
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const showHomeNursingTabs = shouldShowHomeNursingTabs({
    partnerUUID,
    hostname,
    apiBaseUrl: HOME_NURSING_BASE_URL,
    isDev: HOME_NURSING_IS_DEV,
  });
  const showHomeNursingRevenueTracker = shouldShowHomeNursingRevenueTracker({
    partnerUUID,
    hostname,
    apiBaseUrl: HOME_NURSING_BASE_URL,
    isDev: HOME_NURSING_IS_DEV,
  });

  return allMenuItems.filter(item => {
    if (item.requiresCalendarAccess && !canAccessCalendar) {
      return false;
    }
    if (item.href === "/care-plan" && !showHomeNursingTabs) return false;
    if (item.href === "/revenue-tracker" && !showHomeNursingRevenueTracker) return false;
    return true;
  });
}

export default allMenuItems;
